/* Native lazy loading owns the request; only the presentation is enhanced. */
window.GrovaSections.register('progressive-image', '[data-grova-progressive-image]', (root, scope) => {
  const image = root.querySelector('.grova-progressive-image__full');
  if (!image || image.complete) return;

  let disposed = false;
  const reveal = () => {
    if (!disposed) root.classList.remove('is-loading');
  };
  scope.on(image, 'load', async () => {
    try { await image.decode?.(); } catch { /* A decoded frame may already be available. */ }
    reveal();
  });
  scope.on(image, 'error', reveal);
  scope.cleanup(() => {
    disposed = true;
    root.classList.remove('is-loading');
  });
  root.classList.add('is-loading');
  // A cache hit can finish between the first check and attaching listeners.
  if (image.complete) reveal();
});
